import about from './about';
import resume from './resume';
import services from './services';
import contact from './contact';

export default [
  about,
  resume,
  services,
  contact
];
